app.service('outletNav', function(
	productCardConfig,
	productTabs,
	loading,
	outletHashManager,
	sufficientOutletCategory
) {
	let $productCategories, $productPrices, $productBox;
	let $outletNav;

	function setProductPrice(data = {}) {
		const { outletCategoryId } = data;
		let $activePrice;

		if (outletCategoryId) {
			$activePrice = $productPrices.find(
				`[data-outlet-category=${outletCategoryId}]`
			);
		} else {
			$activePrice = $productPrices.find('.prices-box-new');
		}

		$activePrice
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');
	}

	function setProductCategory(data = {}) {
		const { outletCategoryId } = data;
		let $activeCategory;

		if (outletCategoryId) {
			$outletNav
				.find('.js-select-new-product-category')
				.removeClass('is-active')
				.siblings()
				.addClass('is-active');

			$activeCategory = $productCategories.find(
				`[data-outlet-category=${outletCategoryId}]`
			);
		} else {
			$activeCategory = $productCategories.find('.product-category-new');
		}

		$activeCategory
			.addClass('is-active')
			.siblings()
			.removeClass('is-active');

		productCardConfig.setData({ activeOutletCategory: outletCategoryId });

		productTabs.toggleTabs(!!outletCategoryId);
		productTabs.reloadTabs();

		setActiveAdvertisingPlacement(outletCategoryId);

		$('#delivery-date-selected-city').empty();
	}

	function setActiveAdvertisingPlacement(outletCategoryId) {
		if (outletCategoryId) {
			$productBox
				.addClass('product-is-outlet')
				.find('.advertising-placement-outlet')
				.removeClass('is-active')
				.filter(`[data-category-id=${outletCategoryId}]`)
				.addClass('is-active');
		} else {
			$productBox.removeClass('product-is-outlet');
		}
	}

	function setCategoryForProductCard(outletCategoryId) {
		setProductCategory({ outletCategoryId });
		setProductPrice({ outletCategoryId });
	}

	function handleDropdownClick() {
		$(this).toggleClass('is-open');
	}

	function handleNewProductCategorySelect() {
		$(this)
			.addClass('is-active')
			.siblings()
			.removeClass('is-active is-open');

		setProductCategory();
		setProductPrice();

		$outletNav.find('.tabs-dropdown').removeClass('is-open');
	}

	function handleOutletProductCategorySelect() {
		const outletCategoryId = $(this).data('product-category');

		setProductCategory({ outletCategoryId });
		setProductPrice({ outletCategoryId });

		$outletNav.find('.tabs-dropdown').removeClass('is-open');
	}

	function getProductAvailability(huCode) {
		return $.ajax({
			method: 'GET',
			url: '/outletProduct-finder.ltr',
			data: { huCode }
		});
	}

	function getErrorMessage() {
		return $.ajax({
			url: '/message-alert.ltr',
			data: {
				code: 'not-found-outlet-product-for-hu-code'
			}
		});
	}

	function showErrorMessage() {
		getErrorMessage().then(message => {
			$('.sufficient-outlet-offer').prepend(message);
		});
	}

	function checkForOutletCategoryInHash() {
		const outletCategoryId = outletHashManager.getOutletCategoryId();

		if (outletCategoryId) {
			const huCode = outletHashManager.getHuCode();

			if (huCode) {
				productTabs.open('outlet');
				loading.start();

				$.scrollTo('.individual-outlet-offers')
					.then(() => getProductAvailability(huCode))
					.then(outletProductId => {
						sufficientOutletCategory.showIndividualOffer(outletProductId);
						setCategoryForProductCard(outletCategoryId);
					})
					.fail(showErrorMessage)
					.always(loading.stop);
			} else {
				setCategoryForProductCard(outletCategoryId);
			}
		}
	}

	function openOutletTabAndScroll() {
		productTabs.open('outlet');
		$.scrollTo('.individual-outlet-offers');
	}

	function setEvents() {
		$outletNav
			.on(
				'click',
				'.js-select-new-product-category',
				handleNewProductCategorySelect
			)
			.on(
				'click',
				'.js-select-outlet-product-category',
				handleOutletProductCategorySelect
			)
			.on('click', '.tabs-dropdown', handleDropdownClick);

		$('body').on('click', '.choose-individual-offer', openOutletTabAndScroll);
	}

	function init() {
		$productBox = $('.product-main');
		$productCategories = $('.product-categories', $productBox);
		$productPrices = $('.product-prices', $productBox);
		$outletNav = $('.product-outlet-nav');

		setEvents();
		checkForOutletCategoryInHash();
	}

	return { init, setCategoryForProductCard };
});
